import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "md:tw-flex tw-justify-between tw-h-[22px]" }
const _hoisted_2 = { class: "tw-flex tw-h-[22px]" }
const _hoisted_3 = { class: "tw-text-[15px] tw-font-semibold tw-text-[#211F58] tw-mr-[12px]" }
const _hoisted_4 = {
  key: 0,
  class: "custom-global-skeleton tw-w-[120px] tw-h-[15px]"
}
const _hoisted_5 = {
  key: 1,
  class: "custom-global-skeleton tw-w-[120px] tw-h-[15px]"
}
const _hoisted_6 = {
  key: 2,
  class: "tw-flex"
}
const _hoisted_7 = { class: "tw-mr-[20px] tw-text-[15px] tw-font-normal tw-text-[#878787]" }
const _hoisted_8 = { class: "tw-mt-[-1px]" }
const _hoisted_9 = { class: "tw-flex tw-gap-4" }

import { downloadCSV, getComponentUiText } from "@/utils/utilities";
import { getTimeFromNow } from "@/utils/dateTimeUtils";
import ArrowRight from "@/components/svgs/arrowRight.vue";
import ArrowLeft from "@/components/svgs/arrowLeft.vue";
import { computed, PropType } from "vue";
import type { ScansHistoryWebServicesType } from "@/store/scanning";
import { showErrorAPI, showSuccessToast } from "@/services/apiRoutes";
import { getScanReportDiffWebService } from "@/services/scanning";
import { statusScanProgress, TYPE_SCHEDULE } from "@/utils/constants";
import store from "@/store";
import { Scanning } from "@/services/apiRoutes/routes";


export default /*#__PURE__*/_defineComponent({
  __name: 'scanNavigationSpinner',
  props: {
  isShowSwitchScan: {
    type: Boolean,
    required: false,
    default: true,
  },
  isShowPrev: {
    type: Boolean,
    required: true,
  },
  isShowNext: {
    type: Boolean,
    required: true,
  },
  data: {
    type: Object as PropType<
      ScansHistoryWebServicesType["scanReportRuns"][number]
    >,
    required: true,
  },
  scanReportRuns: {
    type: Array,
    required: true,
  },
  scanTargetType: {
    type: String as PropType<keyof typeof TYPE_SCHEDULE>,
    required: false,
    default: TYPE_SCHEDULE.webservices,
  },
  webServicesId: {
    type: String,
    required: true,
  },
  domainId: {
    type: String,
    required: true,
  },
},
  emits: ["switch-scan"],
  setup(__props) {

const props = __props;



const isRefreshing = computed(() => store.state.Scanning.isLoading);

const webserviceScanningId = computed(
  () => store.state.Scanning.webserviceScanningId,
);
const domainScanningId = computed(() => store.state.Scanning.domainScanningId);

const downloadDiffScanReport = async () => {
  let maxScanReportRunId: any = null;

  props.scanReportRuns.forEach((report: any) => {
    if (
      !maxScanReportRunId ||
      parseInt(report.scanReportRunId) > parseInt(maxScanReportRunId)
    ) {
      maxScanReportRunId = report.scanReportRunId;
    }
  });

  try {
    const res = await getScanReportDiffWebService(
      maxScanReportRunId,
      props.data.scanReportRunId,
    );
    if (res) {
      downloadCSV(res, "CurrentDiffScan.csv");
      showSuccessToast(
        getComponentUiText("app-api-scanning-export-csv-success-1"),
      );
    }
  } catch (error: any) {
    showErrorAPI(error, Scanning.getScanReportDiffWebService);
  }
};



const getStartedTime = (time: any) => {
  return getTimeFromNow(time);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(getComponentUiText)(
              "app-scan-scanning-title-scan-date-navigation-spinner-1",
            )), 1),
        (isRefreshing.value && __props.webServicesId === webserviceScanningId.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4))
          : (isRefreshing.value && __props.domainId === domainScanningId.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, _toDisplayString(__props.data.runStatusId === _unref(statusScanProgress).SCAN_IN_PROGRESS
                ? _unref(getComponentUiText)("app-scan-scanning-title-scan-date-now-1")
                : getStartedTime(__props.data.startedAt)), 1),
                _createElementVNode("div", _hoisted_8, [
                  (__props.isShowPrev)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        style: {"cursor":"pointer","margin-right":"8px"},
                        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('switch-scan', 'prev')), ["stop"]))
                      }, [
                        _createVNode(ArrowLeft)
                      ]))
                    : _createCommentVNode("", true),
                  (__props.isShowNext)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        style: {"cursor":"pointer"},
                        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('switch-scan', 'next')), ["stop"]))
                      }, [
                        _createVNode(ArrowRight)
                      ]))
                    : _createCommentVNode("", true),
                  (
                __props.isShowSwitchScan && __props.scanTargetType === _unref(TYPE_SCHEDULE).webservices
              )
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 2,
                        class: "tw-text-[13px] tw-font-normal tw-text-[#387DFF] tw-ml-4",
                        onClick: downloadDiffScanReport
                      }, _toDisplayString(_unref(getComponentUiText)(
                  "app-scan-scanning-view-most-recent-scan-navigation-spinner-download-diff-with-current-scan-1",
                )), 1))
                    : _createCommentVNode("", true)
                ])
              ]))
      ]),
      _createElementVNode("div", _hoisted_9, [
        (__props.isShowSwitchScan)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "tw-text-[13px] tw-font-normal tw-text-[#387DFF]",
              onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.$emit('switch-scan', 'latest')), ["stop"]))
            }, _toDisplayString(_unref(getComponentUiText)(
              "app-scan-scanning-view-most-recent-scan-navigation-spinner-1",
            )), 1))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})